import { createFileRoute } from "@tanstack/react-router";
import { ActivityDetailPage } from "@/modules/activity/presentation/pages/ActivityDetailPage";

export const Route = createFileRoute("/_authenticated/move_/$activityId")({
  component: ActivityDetailRoute,
});

function ActivityDetailRoute() {
  const { activityId } = Route.useParams();
  return <ActivityDetailPage activityId={activityId} />;
}
